import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const style = `
  .nb-wrap { position:relative; }

  .nb-btn { width:38px; height:38px; border-radius:10px; border:1px solid #e8ebf4; background:white; display:flex; align-items:center; justify-content:center; cursor:pointer; transition:all .15s; position:relative; }
  .nb-btn:hover { background:#f0f2f7; border-color:#d0d5e0; }
  .nb-btn svg { width:18px; height:18px; stroke:#6b7194; stroke-width:1.8; fill:none; }

  .nb-badge { position:absolute; top:-5px; right:-5px; min-width:18px; height:18px; border-radius:99px; background:#ef4444; color:white; font-size:.6rem; font-weight:700; display:flex; align-items:center; justify-content:center; padding:0 4px; border:2px solid white; font-family:'Sora',sans-serif; }

  .nb-dropdown { position:absolute; right:0; top:calc(100% + 8px); width:340px; background:white; border-radius:16px; border:1px solid #e8ebf4; box-shadow:0 8px 32px rgba(0,0,0,.12); z-index:9999; overflow:hidden; animation:nbSlide .15s ease; }
  @keyframes nbSlide { from{opacity:0;transform:translateY(-6px)} to{opacity:1;transform:translateY(0)} }

  .nb-header { display:flex; align-items:center; justify-content:space-between; padding:14px 16px; border-bottom:1px solid #f0f2f8; }
  .nb-header-title { font-family:'Sora',sans-serif; font-size:.86rem; font-weight:700; color:#0f1123; }
  .nb-header-actions { display:flex; gap:8px; align-items:center; }
  .nb-mark-all { font-family:'Sora',sans-serif; font-size:.72rem; font-weight:600; color:#3b6ef8; cursor:pointer; border:none; background:none; padding:0; }
  .nb-mark-all:hover { text-decoration:underline; }
  .nb-clear { font-family:'Sora',sans-serif; font-size:.72rem; font-weight:600; color:#9094a8; cursor:pointer; border:none; background:none; padding:0; }
  .nb-clear:hover { color:#ef4444; }

  .nb-list { max-height:360px; overflow-y:auto; scrollbar-width:thin; scrollbar-color:#e0e4f0 transparent; }
  .nb-list::-webkit-scrollbar { width:4px; }
  .nb-list::-webkit-scrollbar-thumb { background:#e0e4f0; border-radius:99px; }

  .nb-item { display:flex; align-items:flex-start; gap:10px; padding:12px 16px; border-bottom:1px solid #f5f6fb; cursor:pointer; transition:background .12s; position:relative; }
  .nb-item:last-child { border-bottom:none; }
  .nb-item:hover { background:#fafbff; }
  .nb-item.unread { background:#f8f9ff; }
  .nb-item.unread::before { content:''; position:absolute; left:0; top:0; bottom:0; width:3px; background:#3b6ef8; border-radius:0 2px 2px 0; }

  .nb-icon-wrap { width:34px; height:34px; border-radius:10px; display:flex; align-items:center; justify-content:center; flex-shrink:0; font-size:1rem; }
  .nb-icon-wrap.leave_approved   { background:#ecfdf5; }
  .nb-icon-wrap.leave_rejected   { background:#fef2f2; }
  .nb-icon-wrap.leave_pending    { background:#fffbeb; }
  .nb-icon-wrap.quiz_assigned    { background:#f3f0ff; }
  .nb-icon-wrap.fee_due          { background:#fffbeb; }
  .nb-icon-wrap.fee_overdue      { background:#fef2f2; }
  .nb-icon-wrap.fee_paid         { background:#ecfdf5; }
  .nb-icon-wrap.attendance_marked{ background:#eef2ff; }
  .nb-icon-wrap.material_uploaded{ background:#f0fdf4; }
  .nb-icon-wrap.salary_finalized { background:#f3f0ff; }
  .nb-icon-wrap.salary_paid      { background:#ecfdf5; }
  .nb-icon-wrap.general          { background:#f0f2f7; }

  .nb-content { flex:1; min-width:0; }
  .nb-title   { font-family:'Sora',sans-serif; font-size:.78rem; font-weight:600; color:#0f1123; margin-bottom:2px; }
  .nb-message { font-family:'Sora',sans-serif; font-size:.72rem; color:#6b7194; line-height:1.45; }
  .nb-time    { font-family:'Sora',sans-serif; font-size:.66rem; color:#b0b5cc; margin-top:3px; }

  .nb-empty { text-align:center; padding:2.5rem 1rem; color:#9094a8; font-family:'Sora',sans-serif; font-size:.8rem; }
  .nb-empty-icon { font-size:2rem; margin-bottom:8px; }

  .nb-footer { padding:10px 16px; border-top:1px solid #f0f2f8; text-align:center; }
  .nb-footer-link { font-family:'Sora',sans-serif; font-size:.74rem; font-weight:600; color:#3b6ef8; cursor:pointer; border:none; background:none; }

  @media (max-width:480px) {
  .nb-dropdown {
    position: fixed;
    top: 60px;
    left: 12px;
    right: 12px;
    width: auto;
  }
  }
`;

const TYPE_ICONS = {
  leave_approved:    '✅',
  leave_rejected:    '❌',
  leave_pending:     '⏳',
  quiz_assigned:     '📝',
  fee_due:           '💳',
  fee_overdue:       '⚠️',
  fee_paid:          '✅',
  attendance_marked: '📋',
  material_uploaded: '📚',
  salary_finalized:  '📊',
  salary_paid:       '💰',
  general:           '🔔',
};

const timeAgo = (date) => {
  const diff = Math.floor((Date.now() - new Date(date)) / 1000);
  if (diff < 60)     return 'Just now';
  if (diff < 3600)   return `${Math.floor(diff/60)}m ago`;
  if (diff < 86400)  return `${Math.floor(diff/3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff/86400)}d ago`;
  return new Date(date).toLocaleDateString('en-US', { day:'numeric', month:'short' });
};

const NotificationBell = () => {
  const [open,         setOpen]         = useState(false);
  const [notifications,setNotifications]= useState([]);
  const [unreadCount,  setUnreadCount]  = useState(0);
  const [loading,      setLoading]      = useState(false);
  const dropdownRef = useRef(null);
  const navigate    = useNavigate();

  // Fetch on mount + every 60s
  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 60000);
    return () => clearInterval(interval);
  }, []);

  // Close on outside click
  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const fetchNotifications = async () => {
    try {
      const { data } = await api.get('/notifications');
      setNotifications(data.notifications || []);
      setUnreadCount(data.unreadCount || 0);
    } catch {}
  };

  const handleOpen = () => {
    setOpen(o => !o);
  };

  const handleClick = async (notif) => {
    // Mark as read
    if (!notif.read) {
      try {
        await api.patch(`/notifications/${notif._id}/read`);
        setNotifications(prev => prev.map(n => n._id === notif._id ? { ...n, read: true } : n));
        setUnreadCount(c => Math.max(0, c - 1));
      } catch {}
    }
    // Navigate if link exists
    if (notif.link) {
      navigate(notif.link);
      setOpen(false);
    }
  };

  const handleMarkAllRead = async () => {
    try {
      await api.patch('/notifications/read-all');
      setNotifications(prev => prev.map(n => ({ ...n, read: true })));
      setUnreadCount(0);
    } catch {}
  };

  const handleClearAll = async () => {
    try {
      await api.delete('/notifications');
      setNotifications([]);
      setUnreadCount(0);
    } catch {}
  };

  return (
    <>
      <style>{style}</style>
      <div className="nb-wrap" ref={dropdownRef}>

        {/* Bell button */}
        <button className="nb-btn" onClick={handleOpen} title="Notifications">
          <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round"
              d="M14.857 17.082a23.848 23.848 0 0 0 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0" />
          </svg>
          {unreadCount > 0 && (
            <div className="nb-badge">{unreadCount > 99 ? '99+' : unreadCount}</div>
          )}
        </button>

        {/* Dropdown */}
        {open && (
          <div className="nb-dropdown">
            <div className="nb-header">
              <div className="nb-header-title">
                Notifications {unreadCount > 0 && <span style={{color:'#3b6ef8'}}>({unreadCount})</span>}
              </div>
              <div className="nb-header-actions">
                {unreadCount > 0 && (
                  <button className="nb-mark-all" onClick={handleMarkAllRead}>Mark all read</button>
                )}
                {notifications.length > 0 && (
                  <button className="nb-clear" onClick={handleClearAll}>Clear all</button>
                )}
              </div>
            </div>

            <div className="nb-list">
              {notifications.length === 0 ? (
                <div className="nb-empty">
                  <div className="nb-empty-icon">🔔</div>
                  <div>No notifications yet</div>
                </div>
              ) : (
                notifications.map(n => (
                  <div key={n._id} className={`nb-item ${n.read ? '' : 'unread'}`} onClick={() => handleClick(n)}>
                    <div className={`nb-icon-wrap ${n.type}`}>
                      {TYPE_ICONS[n.type] || '🔔'}
                    </div>
                    <div className="nb-content">
                      <div className="nb-title">{n.title}</div>
                      <div className="nb-message">{n.message}</div>
                      <div className="nb-time">{timeAgo(n.createdAt)}</div>
                    </div>
                  </div>
                ))
              )}
            </div>

            {notifications.length > 0 && (
              <div className="nb-footer">
                <button className="nb-footer-link" onClick={() => { setOpen(false); }}>
                  Showing last {notifications.length} notifications
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default NotificationBell;